module.exports = __webpack_public_path__ + "static/media/avatars_male_18.d010ce2c.png";